<template>
    <div class="o-header u-posRelative u-bgTertiary" 
         :class="{ 
             '-large': isModuleStarted && progress.length >= 2 && progress[1] !== 0, 
             '-xl': normalizedPath === '#/home',
             '-noRoundedBorders': normalizedPath === '#/profile'
         }">
        <div class="o-header__inner u-container">
            <!-- Special Header for #/home -->
            <div class="o-header__home" v-if="normalizedPath === '#/home'">
                <a href="/#/profile" class="o-header__avatar a-avatar">
                    <div class="a-circle -primaryLighter">
                        {{ generateInitials(user?.first_name, user?.last_name) }}
                    </div>
                </a>
                <div class="o-header__homeItems">
                    <div class="o-header__date u-fs12 u-fw300">
                        {{ user?.date }}
                    </div>
                    <h1 class="o-header__title u-fs25" v-if="user?.first_name">
                        <span class="u-fw500">{{ $t('home.greeting') }}</span>&nbsp;
                        <span class="u-colorPrimary">{{ user?.first_name }}</span>
                    </h1>
                </div>
                <LevelPoints class="-absolute" />
            </div>

            <!-- Default Header -->
            <div class="o-header__items u-posRelative" v-else>
                <a v-if="backUrl != 'goBack'" :href="backUrl" class="o-header__back u-colorPrimary"><i class='icon bx bx-arrow-back'></i></a>
                <div v-else @click="historyBack" class="o-header__back u-colorPrimary"><i class='icon bx bx-arrow-back'></i></div>
                <h2 class="o-header__title -overflow u-mb0 u-colorSecondary">
                    <div v-if="stepNumber !== 0" class="o-header__circle a-circle -small -primary">{{ stepNumber }}</div>
                    {{ headerTitle }}
                </h2>
            </div>

            <Progress 
                :current="progress[0]" 
                :total="progress[1]" 
                v-if="isModuleStarted && progress.length >= 2 && progress[1] !== 0" 
            />
        </div>

    </div>
</template>

<script setup>
import { inject, ref, watch, onMounted, computed } from 'vue';
import api from '../../services/api';
import Progress from '../atoms/Progress.vue';
import { generateInitials } from '../../utils/globalFunctions';

// Components
import LevelPoints from '../molecules/LevelPoints.vue';

const currentPath = inject('currentPath');
const routes = inject('routes');
const backUrl = ref('');
const user = ref(null);

const props = defineProps({
    headerTitle: {
        type: String,
        default: ''
    },
    stepNumber: {
        type: Number,
        default: 0
    },
    progress: {
        type: Array,
        default: () => []
    },
    isModuleStarted: {
        type: Boolean,
        default: false
    }
});

const normalizedPath = computed(() => {
    if (currentPath.value === '/#/' || currentPath.value === '#/') {
        return '#/home';
    }
    return currentPath.value;
});

const updateBackButton = (newPath) => {
    const normalized = newPath.startsWith('/') ? newPath : `/${newPath}`;
    if (routes[normalized]) {
        backUrl.value = routes[normalized].backUrl;
    } else {
        for (const route in routes) {
            const regex = new RegExp('^' + route.replace(':id', '\\d+') + '$');
            if (regex.test(normalized)) {
                backUrl.value = routes[route].backUrl;
                break;
            }
        }
    }
};

const fetchUserInfo = async () => {
    try {
        const response = await api.get('/user-info');
        if (response.status === 200 && response.data.length !== 0) {
            user.value = response.data;
        }
    } catch (error) {
        console.error('Error fetching user info:', error);
    }
};

const historyBack = () => {
    history.back();
};

watch(currentPath, (newPath) => {
    const normalizedPathValue = normalizedPath.value;
    updateBackButton(normalizedPathValue);

    if (normalizedPathValue === '#/home') {
        fetchUserInfo();
    }
});

onMounted(() => {
    const normalizedPathValue = normalizedPath.value;
    updateBackButton(normalizedPathValue);

    if (normalizedPathValue === '#/home') {
        fetchUserInfo();
    }
});
</script>
